import React from 'react'
import Header from 'components/Header'
import Footer from 'components/Footer'
import ContactFormContainer from 'containers/ContactFormContainer'
import Aux from 'hoc/Auxiliary'
import Meta from 'components/Meta'

export const View = () => {
	return <Aux>
		<Meta page='contact' />
		<Header title='Свържи се с нас'/>
		<div className='c-content'>
			<div className='o-wrapper u-padding-vertical-large'>
				<div className='u-bg--white u-padding-horizontal u-padding-vertical-large u-border-radius u-box-shadow'>
					<div className='o-layout o-layout--center'>
						<div className='o-layout__item u-1/1 u-1/2@tablet'>
							<ContactFormContainer />
						</div>
					</div>
				</div>
			</div>
		</div>
		<Footer selectedMode='monetary' />
	</Aux>
}

export default View
